import getCharts from '../getCharts'
import { QuesitonBank } from '../../constants/api.config'

export default async function SaveQuestionBank(questions,diagnosis, mode) {
  try {
    const payload = {questions,diagnosis, mode}
    const res = await getCharts(QuesitonBank, payload)
    return res.data
  } catch (error) {
    return error
  }
}
